export default {
  'Renovação Próxima': 1,
  'Aguardando Contato': 2,
  'Aguardando Documentação': 15,
  'Aguardando Aprovação': 18,
  'Finalizada': 16,
  'Cancelada' : 9
}
